/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubscriptionPlan {
    None = 'None',
    Monthly = 'Monthly',
    YearlyBundle = 'YearlyBundle',
    AlaCarte = 'AlaCarte',
    Yearly = 'Yearly'
}

export function SubscriptionPlanFromJSON(json: any): SubscriptionPlan {
    return SubscriptionPlanFromJSONTyped(json, false);
}

export function SubscriptionPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPlan {
    return json as SubscriptionPlan;
}

export function SubscriptionPlanToJSON(value?: SubscriptionPlan | null): any {
    return value as any;
}

